import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { useIframeCommunication } from '../../hooks/useIframeCommunication';
import { FileEdit } from 'lucide-react';
import Footer from '../../components/Footer';
import ArticlesSearchBlock from '../../components/ArticlesSearchBlock';
import './ArticlesPage.css';

const ArticlesPage = () => {
    useIframeCommunication();
    const isIframe = useMemo(() => window.self !== window.top, []);

    const { data: authorOptions = [] } = useQuery(
        'publishedArticleAuthors',
        async () => {
            const res = await axios.get(`${API_BASE_URL}/articles/published-authors`);
            return res.data;
        }
    );

    const { data: articles = [], isLoading } = useQuery(
        'articlesSearchAll',
        async () => {
            const res = await axios.get(`${API_BASE_URL}/articles/search`);
            return res.data;
        }
    );

    return (
        <div className={`articles-page articles-page--search${isIframe ? ' articles-page--iframe' : ''}`}>
            {!isIframe && (
                <div className="articles-search-header">
                    <div className="articles-search-header-icon">
                        <FileEdit size={32} />
                    </div>
                    <h1>Статьи</h1>
                    <p className="articles-search-subtitle">Поиск по статьям</p>
                </div>
            )}

            <ArticlesSearchBlock
                articles={articles}
                authorOptions={authorOptions}
                isLoading={isLoading}
            />

            <Footer />
        </div>
    );
};

export default ArticlesPage;
